/**
 * Функция, чтобы понять, что тостов на экране больше заданного лимита.
 * @param toastsStack - список всех тостов (видимых и скрытых)
 * @param maxToastsNumber - лимит видимых тостов на экране
 * @returns boolean - превышает ли количество тостов на экране заданное ограничение
 */
export function getIsMaxToastsNumberExceeded(toastsStack, maxToastsNumber) {
  const allVisibleToastsNumber = toastsStack.filter(toast => !toast.hidden).length;
  return maxToastsNumber !== undefined && allVisibleToastsNumber >= maxToastsNumber;
}